export default {
    // ========== Página 403 - Acceso Denegado ==========
    page403Title: 'Acceso restringido',
    page403Message: 'Lo sentimos, no tienes permiso para ver esta página.',
    returnHome: 'Volver al Inicio',

    // ========== Página 404 - No Encontrado ==========
    page404Title: '¡Página no encontrada!',
    page404Message: 'Lo sentimos, la página que estás buscando no existe.',

    // ========== Página 500 - Error del Servidor ==========
    page500Title: 'Error del servidor',
    page500Message: 'Lo sentimos, ha ocurrido un error en el servidor.',

    // ========== Página de Mantenimiento (PageMaintenance) ==========
    pageMaintenanceTitle: 'Página en Mantenimiento',
    pageMaintenanceMessage: 'Estamos trabajando para mejorar su experiencia. Esta página estará disponible nuevamente en breve.',
    pageMaintenanceButton: 'Volver al Inicio',

    // ========== Vista de Mantenimiento (MaintenanceView) ==========
    maintenanceViewTitle: '¡Hola! ¡Nos encontramos en mantenimiento!',
    maintenanceViewMessage: 'Disculpa las molestias, pero estamos realizando tareas de mantenimiento en la web. Estaremos de vuelta en breve. Si necesitas hablar con nosotros de forma urgente,',
    maintenanceViewEmailLink: 'puedes enviarnos un email',
    maintenanceViewTeam: '— El equipo KLearning',
}
